import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import ToastContext from "../../../contexts/ToastContext";
import "./toast-container.less";
export default function ToastContainer() {
    const { toasts, dismissToast } = useContext(ToastContext);
    if (toasts.length === 0) {
        return null;
    }
    return (_jsx("div", { className: "HGU__toast-container", children: toasts.map((toast) => (_jsxs("div", { className: `HGU__toast HGU__toast--${toast.type}`, children: [_jsx("span", { className: "HGU__toast-message", children: toast.message }), _jsx("button", { className: "HGU__toast-close", onClick: () => dismissToast(toast.id), "aria-label": "Dismiss", children: "\u00D7" })] }, toast.id))) }));
}
